(function() {
  function checkNotes(element) {
    var elementShow = element.parent().parent().parent().children(element.data('show'));

    if (element.is(':checked')) {
      $(elementShow).addClass('open');
      setTimeout(function() {
        var textarea = $(elementShow).find('textarea');
        if (textarea.data('content')) {
          textarea.val(textarea.data('content'));
        }
        textarea.focus();
      }, 500);
      if (element.data('property')) {
        element.attr('name', 'properties[' + element.data('property') + ']');
      }
    } else {
      $(elementShow).removeClass('open');
      $(elementShow).find('textarea').data('content', $(elementShow).find('textarea').val());

      setTimeout(function() {
        $(elementShow).find('textarea').val('');
      }, 1);
      if (element.data('property')) {
        element.removeAttr('name');
      }
    }
  }

  function addName(element) {
    var propertyName = element.data('property');
    if (!propertyName) {
      propertyName = element.data('custom-property');
    }
    if (element.val() !== '') {
      element.attr('name', 'properties[' + propertyName + ']');
    } else {
      element.removeAttr('name');
    }
  }

  function initSection(section) {
    var productId = section.dataset.productId;
    if (!productId) return;

    var productWrap = $('#product-item-' + productId);
    if (!productWrap.length) return;

    var productKey = parseInt(productId, 10);

    $.ajax({
      url: '/cart.js',
      type: 'GET',
      dataType: 'json',
      contentType: false,
      processData: false
    }).done(function(data) {
      $('#loading-overlay').hide();
      var cart = data || {};
      var item = (cart.items || []).filter(function(cartItem) {
        return cartItem.product_id == productKey;
      })[0];

      for (var i = 0; i < 5; i++) {
        var specialRequestName = 'Special Request ' + i;
        var requestField = section.querySelector('[name="' + specialRequestName + '"]');
        if (item && item.properties && item.properties[specialRequestName] && requestField) {
          requestField.value = item.properties[specialRequestName];
          requestField.dataset.content = item.properties[specialRequestName];
          var checkbox = requestField.parentNode.parentNode.parentNode.querySelector('input[type=checkbox]');
          if (checkbox) checkbox.checked = true;
        }
      }

      $(section)
        .find('.checkbox-custom')
        .each(function() {
          checkNotes($(this));
        });
    });

    productWrap
      .find('.note-textarea:not(.giftnote-textarea)')
      .off('keydown.pdpGiftRequests')
      .on('keydown.pdpGiftRequests', function() {
        addName($(this));
      });

    productWrap
      .find('.property .check-wrap input')
      .off('change.pdpGiftRequests')
      .on('change.pdpGiftRequests', function() {
        checkNotes($(this));
      });

    $(section)
      .find('textarea')
      .off('keyup.pdpGiftRequests paste.pdpGiftRequests')
      .on('keyup.pdpGiftRequests paste.pdpGiftRequests', function() {
        var textarea = $(this);
        var maxLength = parseInt(textarea.attr('maxlength'), 10);
        if (maxLength > 0) {
          textarea.val(textarea.val().substring(0, maxLength));
          textarea.parent().find('.counter span').text(textarea.val().length);
        }
      });

    var validation = function() {
      var requiredField = $(section).find('.required-if-other-selected');
      if (requiredField.length) {
        if (requiredField.val().trim().length === 0) {
          requiredField.addClass('error');
          return false;
        }
        if (
          (requiredField.val() !== '' && requiredField.attr('name') === undefined) ||
          (requiredField.val() !== '' && requiredField.attr('name').indexOf('properties') === -1)
        ) {
          addName(requiredField);
        }
      }

      return true;
    };

    productWrap
      .find('.add-to-cart-form')
      .off('submit.pdpGiftRequestsNames')
      .on('submit.pdpGiftRequestsNames', function() {
        productWrap.find('.note-textarea:not(.giftnote-textarea)').each(function() {
          addName($(this));
        });

        var giftNote = [];
        productWrap.find('.giftnote-field').each(function() {
          if ($(this).val() !== '') {
            giftNote.push($(this).data('property') + ': ' + $(this).val());
          }
        });

        var joinedGiftNote = giftNote.join(' -|- ');
        if (joinedGiftNote !== '') {
          productWrap.find('.giftnote-join').val(joinedGiftNote);
        }
        addName(productWrap.find('.giftnote-join'));
      });

    productWrap
      .find('.add-to-cart-form')
      .off('submit.pdpGiftRequestsValidation')
      .on('submit.pdpGiftRequestsValidation', function() {
        return validation();
      })
      .data('validation', validation);
  }

  $(function() {
    document
      .querySelectorAll('.giftnote-and-instructions[data-section-type="pdp-gift-requests"]')
      .forEach(initSection);
  });
})();
